
'use strict'

module.exports = require('./multiselect-react-dropdown.cjs.development.js')
